export const appChevronRightIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.59998 7.4L9.99998 6L16 12L9.99998 18L8.59998 16.6L13.2 12L8.59998 7.4Z" fill="#3B3B3B"/></svg>`,
    name: 'chevron-right'
};